import { QualityOutputMetricEnum } from '../../schemas';

export const getQualityOutputMetricLabel = (qualityOutputMetric: QualityOutputMetricEnum) => {
  switch (qualityOutputMetric) {
    case QualityOutputMetricEnum.UBC:
      return 'UBC';
    case QualityOutputMetricEnum.ALUMINIUM_FOOD_CAN:
      return 'Aluminium Food Can';
    case QualityOutputMetricEnum.UBC_AND_ALUMINIUM_FOOD_CAN:
      return 'UBC & Aluminium Food Can';
    case QualityOutputMetricEnum.OTHER_ALUMINIUM:
      return 'Other Aluminium';
    case QualityOutputMetricEnum.ALUMINIUM_FOIL_AND_TRAY:
      return 'Foil and Tray';
    case QualityOutputMetricEnum.TOTAL_ALUMINIUM:
      return 'Total Aluminium';
    case QualityOutputMetricEnum.NON_METAL:
      return 'Non Metal';
    case QualityOutputMetricEnum.OTHER_METAL:
      return 'Other Metal';
    case QualityOutputMetricEnum.FERROUS_METAL:
      return 'Ferrous Metal';
    case QualityOutputMetricEnum.NON_ALUMINIUM:
      return 'Non-Aluminium';
    case QualityOutputMetricEnum.PET_BOTTLES:
      return 'PET Bottles';
    case QualityOutputMetricEnum.CLEAR_PET_BOTTLES:
      return 'Clear PET Bottles';
    case QualityOutputMetricEnum.GREEN_PET_BOTTLES:
      return 'Green PET Bottles';
    case QualityOutputMetricEnum.LIGHT_BLUE_PET_BOTTLES:
      return 'Light Blue PET Bottles';
    case QualityOutputMetricEnum.DARK_BLUE_PET_BOTTLES:
      return 'Dark Blue PET Bottles';
    case QualityOutputMetricEnum.CLEAR_AND_LIGHT_BLUE_PET_BOTTLES:
      return 'Clear & Light Blue PET Bottles';
    case QualityOutputMetricEnum.OTHER_COLOURS:
      return 'Other Colours';
    case QualityOutputMetricEnum.NON_PET_BOTTLES:
      return 'Non Pet Bottles';
    case QualityOutputMetricEnum.TOTAL_IMPURITIES:
      return 'Total Impurities';
    case QualityOutputMetricEnum.NON_FOOD_GRADE_BOTTLES:
      return 'Non Food Grade Bottles';
    case QualityOutputMetricEnum.PET_TRAYS:
      return 'PET Trays';
    case QualityOutputMetricEnum.FILM:
      return 'Film';
    case QualityOutputMetricEnum.OTHER_PLASTIC:
      return 'Other Plastic';
    case QualityOutputMetricEnum.METAL:
      return 'Metal';
    case QualityOutputMetricEnum.NON_PLASTIC:
      return 'Non Plastic';
    // Add missing enum values
    case QualityOutputMetricEnum.CLEAR_PET_FLAKES:
      return 'Clear PET Flakes';
    case QualityOutputMetricEnum.LIGHT_BLUE_PET_FLAKES:
      return 'Light Blue PET Flakes';
    case QualityOutputMetricEnum.CLEAR_AND_LIGHT_BLUE_PET_FLAKES:
      return 'Clear & Light Blue PET Flakes';
    case QualityOutputMetricEnum.DARK_BLUE_PET_FLAKES:
      return 'Dark Blue PET Flakes';
    case QualityOutputMetricEnum.GREEN_PET_FLAKES:
      return 'Green PET Flakes';
    case QualityOutputMetricEnum.YELLOW_PET_FLAKES:
      return 'Yellow PET Flakes';
    case QualityOutputMetricEnum.COLOURED_PET_FLAKES:
      return 'Coloured PET Flakes';
    case QualityOutputMetricEnum.PARTICLE_SIZE_LT5MM:
      return 'Particle Size <5mm';
    case QualityOutputMetricEnum.PARTICLE_SIZE_5_10MM:
      return 'Particle Size 5-10mm';
    case QualityOutputMetricEnum.PARTICLE_SIZE_10_12MM:
      return 'Particle Size 10-12mm';
    case QualityOutputMetricEnum.PARTICLE_SIZE_GT12MM:
      return 'Particle Size >12mm';
    case QualityOutputMetricEnum.INTRINSIC_VISCOSITY:
      return 'Intrinsic Viscosity';
    case QualityOutputMetricEnum.PVC:
      return 'PVC';
    case QualityOutputMetricEnum.NON_FERROUS_METAL:
      return 'Non Ferrous Metal';
    case QualityOutputMetricEnum.GLUE:
      return 'Glue';
    case QualityOutputMetricEnum.MOISTURE:
      return 'Moisture';
    case QualityOutputMetricEnum.ALUMINIUM_TT_ALUMINIUM:
      return 'Aluminium Taint Tabor';
    case QualityOutputMetricEnum.ALUMINIUM_TT_CAST:
      return 'Cast Aluminium';
    case QualityOutputMetricEnum.ALUMINIUM_TT_FINES:
      return 'Fines';
    case QualityOutputMetricEnum.ALUMINIUM_TT_FOIL_UBC:
      return 'Foil/UBC';
    case QualityOutputMetricEnum.ALUMINIUM_TT_RADIATOR:
      return 'Radiator';
    case QualityOutputMetricEnum.ALUMINIUM_ZORBA_NON_FERROUS:
      return 'Non Ferrous';
    case QualityOutputMetricEnum.ALUMINIUM_ZORBA_BRASS_OR_COPPER:
      return 'Brass or Copper';
    case QualityOutputMetricEnum.ALUMINIUM_ZORBA_FINES:
      return 'Fines';
    case QualityOutputMetricEnum.ALUMINIUM_ZORBA_NON_METAL:
      return 'Non Metal';
    case QualityOutputMetricEnum.ALUMINIUM_ZORBA_UBC:
      return 'UBC';
    case QualityOutputMetricEnum.ALUMINIUM_ZORBA_OTHER_METAL:
      return 'Other Metal';
    default:
      return 'Unknown';
  }
};
